
// import 'babel-polyfill';
import Vue from "vue";
import App from "./App.vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import "./assets/js/swiper.js";
import "./assets/css/swiper.css";
import "font-awesome/css/font-awesome.min.css";
import home from "./api/home/home";
import axios from "axios";
import store from "./store";
import "./assets/css/element-variables.scss";
//cookie
import VueCookie from "vue-cookie";
import lottie from "vue-lottie";
import "animate.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// 修改弹框样式
import msg from "@/assets/js/msg.js";
import Loading from "@/assets/js/loading";
import getCosUrl from "@/assets/js/cos.js";
import VueSimpleVerify from "vue-simple-verify";
import "../node_modules/vue-simple-verify/dist/vue-simple-verify.css";
import VueScrollLock from 'vue-scroll-lock'
import zhLang from 'element-ui/lib/locale/lang/zh-CN'; // 引入官方的中文国际化
import locale from '@/assets/js/locale/cn.js'; // 引入自己的
// 水印
import watermark from './assets/js/watermark.js'
// main.js
Vue.prototype.$env = process.env

Vue.prototype.$watermark = watermark
Vue.use(VueScrollLock)
// main.js
Vue.prototype.$scrollTo = (x = 0, y = 0, type = "smooth") => {
  window.scrollTo({
    top: x,
    left: y,
    behavior: type, // 滚动行为：smooth平滑滚动，instant瞬间滚动，默认值auto，等同于instant
  });
};

Vue.prototype.$msg = msg;
Vue.component("vue-simple-verify", VueSimpleVerify);

Vue.component("lottie", lottie);
Vue.prototype.$home = home;
Vue.prototype.$axios = axios;
Vue.prototype.$bus = new Vue();
Vue.prototype.$getCosUrl = getCosUrl;

Vue.use(ElementUI,{
  locale: { ...zhLang, ...locale }, // 使用本地的 locale 去覆盖官方的 zhLang
});
Vue.use(VueCookie);
Vue.use(Loading);

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
